import cookies from 'js-cookie';
import moment from 'moment';
var CryptoJS = require("crypto-js");
const apiSecretKey = ( process.env.REACT_APP_DEPLOYMENT_ENV === 'production' ) ? "P98AEF2N3ER1E4U78Y903FJ49TPR8AD5" : "08PAEF2N3201E45678903FJ496948AD5";
const AUTH_COOKIE_NAME = ( process.env.REACT_APP_DEPLOYMENT_ENV === 'production' ) ? 'KURE_AUTH_TOKEN' : 'DEV_KURE_AUTH_TOKEN';
const TIME_ZONE_COOKIE_NAME = ( process.env.REACT_APP_DEPLOYMENT_ENV === 'production' ) ? 'KURE_TIME_ZONE_MSG' : 'DEV_KURE_TIME_ZONE_MSG';

export function getAccessToken() {
    // Access token
    const utcTime               = ''+moment.utc().valueOf();
    const encryptedBase64Key    = Buffer.from(apiSecretKey).toString('base64');    
    const parsedBase64Key       = CryptoJS.enc.Base64.parse(encryptedBase64Key);
    // Encryption process
    const plaintText    = utcTime.toString();
    const encryptedData = CryptoJS.AES.encrypt(plaintText, parsedBase64Key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    
    const accessToken = (encryptedData.toString());
	return accessToken;
}

export function setTimeZoneCookie() {
	cookies.set(TIME_ZONE_COOKIE_NAME, 'yes');
	cookies.set(TIME_ZONE_COOKIE_NAME, 'yes', {domain : "kureapp.com"});
}

export function removeTimeZoneCookie() {
	cookies.remove(TIME_ZONE_COOKIE_NAME);
	cookies.remove(TIME_ZONE_COOKIE_NAME, {domain : "kureapp.com"});
}

export function getTimeZoneCookie() {
	return cookies.get(TIME_ZONE_COOKIE_NAME);
}

export function isAuthCookiePresent() {
	// return true;
	return (
		cookies.get(AUTH_COOKIE_NAME) && cookies.get(AUTH_COOKIE_NAME) !== null
	);
}

export function saveAuthCookie(cookieValue) {
	cookies.set(AUTH_COOKIE_NAME, cookieValue, {domain : "kureapp.com"});
}

export function removeAuthCookie() {
	cookies.remove(AUTH_COOKIE_NAME);
	cookies.remove(AUTH_COOKIE_NAME, {domain : "kureapp.com"});
}

export function getAuthCookie() {
	// return "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI5MTc3Nzc3NzEwMTkiLCJhdWRpZW5jZSI6IndlYiIsImNyZWF0ZWQiOjE1OTA2NDM4NzQwMDksImV4cCI6MTYwMjczOTg3NH0._qHf1jPwQBOlUENifv6kEA8aNW4ARISNlT58SFdCfQeZK45qtRQCme9TWHdbqqTyjMRRGCqoylPJfk-mrivnFA";
	return cookies.get(AUTH_COOKIE_NAME);
}

export function getAuthTokenKey() {
	return AUTH_COOKIE_NAME;
}

// set PORT=6500 && react-scripts start
// set PORT=6500 && REACT_APP_DEPLOYMENT_ENV=production react-scripts start